import React, {FC, useState} from 'react'
import {Modal, Button} from 'react-bootstrap'
import LoadingButtonWrapper from './LoadingButtonWrapper'
import SafeHTMLRenderer from './SafeHtmlRenderer'

type Prop = {
  show: boolean
  handleClose: any
  handleConfirm: any
  body?: string | any | null
  name: string | null
  isLoading?: boolean
  error?: any
  disableConfirm?: boolean
  isHtml?: boolean
}

const Confirm: FC<Prop> = ({
  show,
  handleClose,
  handleConfirm,
  name = null,
  body = null,
  isLoading = false,
  error = null,
  disableConfirm = false,
  isHtml = false,
}) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header className='text-white'>
        <Modal.Title className='text-white'>{name ?? 'Confirm Delete'}</Modal.Title>
        <div
          className='btn btn-icon btn-sm btn-active-icon-primary p-0 h-auto'
          data-kt-students-modal-action='close'
          onClick={handleClose}
          style={{cursor: 'pointer'}}
        >
          <i className='fa-solid fa-xmark fs-2'></i>
        </div>
      </Modal.Header>
      <Modal.Body>
        {error ? (
          <div className='mb-lg-5 alert alert-danger'>
            <div className='alert-text font-weight-bold'>{error}</div>
          </div>
        ) : (
          ''
        )}
        {isHtml && (
          <>
            <SafeHTMLRenderer htmlString={body} />
          </>
        )}

        {!isHtml && <div>{body ?? 'Are you sure you want to delete item?'}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={handleClose} disabled={isLoading}>
          Cancel
        </Button>
        <LoadingButtonWrapper isLoading={isLoading}>
          <button
            className='btn btn-warning'
            onClick={handleConfirm}
            disabled={isLoading || disableConfirm}
          >
            {isLoading && <i className='fa-solid fa-spinner fa-spin-pulse'></i>} Confirm
          </button>
        </LoadingButtonWrapper>
      </Modal.Footer>
    </Modal>
  )
}

export {Confirm}
